module.exports = __webpack_public_path__ + "img/agilidade_na_troca_icon.645564e8.svg";